<template>
  <div>
    <div class="news-filters">
      <div class="container">
        <div class="news-filters__filter">
          <div class="news-filters__filter-dropdown" @click="toggleDropdown">
            <span>Filter</span>
            <i :class="{ 'icon-chevron-down': !showDropdown, 'icon-chevron-up': showDropdown }"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="news-filters__filter-dropdown-content" v-show="showDropdown">
      <DropdownFilter
        v-for="(category, index) in services"
        :key="`${index}-${category.id}`"
        :category="category"
        :selectedValue="filters[index]"
        @update="
          filters[index] = $event;
          getContent();
          showDropdown = false;
        "
      ></DropdownFilter>
    </div>
    <div class="page-subnavigation__actions--mobile-below"></div>
    <div class="news">
      <div class="container">
        <ErrorIndicator v-if="!loading && error" />
        <LoadingIndicator v-if="loading" />
        <div v-if="!loading && !error">
          <div v-for="(category, index) in content" :key="index">
            <div class="news-block__cards" v-if="category.displayType === 'Cards'">
              <div class="news-block__cards-header">
                <h2 class="insights__section-title">{{ category.title }}</h2>
                <div class="news-block__cards-filters" v-if="category.showRelatedContentFilters">
                  <DropdownFilter
                    v-for="(category, index) in services"
                    :key="`${index}-${category.id}`"
                    :category="category"
                    :selectedValue="filters[index]"
                    @update="
                      filters[index] = $event;
                      getContent();
                    "
                  ></DropdownFilter>
                </div>
              </div>

              <div class="news-block__container">
                <div class="news-block__section news-block__section--left">
                  <template v-for="(article, index) in category.articles" :key="index + '-left'">
                    <NewsBlock v-if="index < 2" :url="article.url" :image="null" :title="article.title" :type="article.category" :published="article.published" />
                  </template>
                </div>
                <div class="news-block__section news-block__section--right">
                  <template v-for="(article, index) in category.articles" :key="index + '-right'">
                    <NewsBlock v-if="index > 1 && index < 5" :url="article.url" :image="null" :title="article.title" :type="article.category" :published="article.published" />
                  </template>
                </div>
              </div>
            </div>
            <div class="news-block__grid" v-if="category.displayType === 'Grid'">
              <h2 class="insights__section-title">{{ category.title }}</h2>
              <div class="news-block__grid-wrapper">
                <a v-for="(article, index) in category.articles" :key="index + '-regular'" :href="article.url" class="news-block__grid-item">
                  <div class="news-block__grid-meta">
                    <span>{{ article.published }}</span>
                  </div>
                  <h3 class="news-block__grid-title">{{ article.title }}</h3>
                </a>
              </div>
            </div>
            <div v-if="!category.articles || category.articles.length === 0" class="news-block__no-results">
              <h4>No results found matching your filters.</h4>
            </div>
            <div class="news-block__button">
              <a :href="`${category.url}${filterQueryString ? '?'+filterQueryString : ''}`" class="button">{{ category.viewAllButtonTitle ? category.viewAllButtonTitle : `View all ${category.title}` }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

// Components
import NewsBlock from "../News/NewsBlock.vue";
import LoadingIndicator from "../Global/LoadingIndicator.vue";
import ErrorIndicator from "../Global/ErrorIndicator.vue";
import DropdownFilter from "../FormFields/DropdownFilter.vue";

export default {
  components: {
    NewsBlock,
    LoadingIndicator,
    ErrorIndicator,
    DropdownFilter,
  },
  data() {
    return {
      error: false,
      loading: false,
      showDropdown: false,
      skip: 0,
      take: 12,
      content: [],
      services: [],
      filters: ["", "", ""],
    };
  },
    mounted() {

        const urlParams = new URLSearchParams(window.location.search);
        const practice = urlParams.get('practice');
        const industry = urlParams.get('industry');
        const region = urlParams.get('region');
        if (practice) {
            this.filters[0] = practice
        }
        if (industry) {
            this.filters[1] = industry
        }
        if (region) {
            this.filters[2] = region
        }

    this.getServices();
    this.getContent();

    // We need to move the primary actions below the filters
    let actions = document.querySelector('.page-subnavigation__actions--mobile');
    let target = document.querySelector('.page-subnavigation__actions--mobile-below');
    target.before(actions);
},
computed: {
    filterQueryString() {
        let filters = {};
        if (this.filters[0] != "") {
            filters.practice = this.filters[0];
        }
        if (this.filters[1] != "") {
            filters.industry = this.filters[1];
        }
        if (this.filters[2] != "") {
            filters.region = this.filters[2];
        }
        const params = new URLSearchParams(filters);
        return params.toString();
    }
  },
  methods: {
    toggleDropdown: function () {
      this.showDropdown = !this.showDropdown;
    },
    getServices: function () {
      this.loading = true;
      axios
        .post(
          "/api/services/filter-list?culture=en",
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.services = response.data.categories;
        })
        .catch((err) => {
          this.error = true;
        });
    },
    getContent: function () {
        let filters = [];
        if (this.filters[0] != "") {
            filters.push("&practice=" + this.filters[0]);
        }
        if (this.filters[1] != "") {
            filters.push("&industry=" + this.filters[1]);
        }
        if (this.filters[2] != "") {
            filters.push("&region=" + this.filters[2]);
        }

        let newUrl = `${window.location.origin}${window.location.pathname}?${filters.join("")}`;
        if (history.pushState) {
            history.pushState({}, "", newUrl);
        }

      axios
        .post(
          "/api/news" + `?skip=${this.skip}&take=${this.take}${filters.join("")}`,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.content = response.data.categories;
          this.loading = false;
        })
        .catch((err) => {
          this.error = true;
          this.loading = false;
        });
    },
  },
};
</script>
